var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 664.14 728.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#e59f3c;stroke-width:14px;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-3{fill:#e59f3c;}.cls-4{fill:#1f2dd9;}.cls-2{stroke:#1f2dd9;stroke-width:10px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "300.12 378.66 105.31 384.02 5.67 190.29 107.52 7.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "563.21 715.54 655.89 544.1 527.95 367.78 319.27 376.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 569.63,
    cy: 702.59,
    r: 25.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 305.66,
    cy: 377.92,
    r: 25.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 94.35,
    cy: 25.45,
    r: 25.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknow);
export default __webpack_public_path__ + "static/media/unknow.fe0965b3a54da85eade6d6260c731557.svg";
export { ForwardRef as ReactComponent };